<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeActivityBase from '../../../../employee_activity/components/EmployeeActivityBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Shifts',
                route: '/(app)/schedule/shifts/',
            },
            {
                label: 'New Shift',
                route: '/(app)/schedule/shifts.wizard',
            },
            {
                label: 'Activity',
                route: '/(app)/schedule/activity/',
            },
            {
                label: 'Calendar',
                route: '/(app)/schedule/calendar/',
            }
        ],
    }
})
</script>

<template>
  <EmployeeActivityBase />
</template>